import Vue from "vue";
import Vuex from "vuex";
import authentication from "./modules/authentication";
import customization from "./modules/customization";
import userData from "./modules/user-data";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    authentication,
    customization,
    userData,
  },
});
